import type { BaseOptionType } from "antd/lib/select"
import { useMemo } from "react"

import { useGlobalFilterOptions } from "../../DashboardPage/hooks/useGlobalFilterOptions.ts"
import { LEAD_STATUSES_MAP } from "../../Lead/constants/lead-statuses.ts"
import type { ReportFilterDimension } from "../types/canvas.types.ts"

export type ReportFilterOptions = Record<
  ReportFilterDimension,
  BaseOptionType[]
>

export interface UseReportFilterOptions {
  options: ReportFilterOptions
  loading: boolean
}

// Reuses the dashboard's global-filter option loading for the six dashboard dims,
// and adds "status" (lead status) — a dim the dashboard's FilterBar doesn't carry.
export const useReportFilterOptions = (): UseReportFilterOptions => {
  const { options: baseOptions, loading } = useGlobalFilterOptions("reports")

  const statusOptions = useMemo<BaseOptionType[]>(
    () =>
      Object.values(LEAD_STATUSES_MAP).map((status) => ({
        label: status.label,
        value: String(status.value)
      })),
    []
  )

  const options: ReportFilterOptions = useMemo(
    () => ({ ...baseOptions, status: statusOptions }),
    [baseOptions, statusOptions]
  )

  return { options, loading }
}
